module.exports = __webpack_public_path__ + "img/Weapon_299.af4d2cd7.png";